<template>
  <DialogTemplateToolkit
    :data-qa="`${dataQa}-dialog`"
    :dialog="modalShow"
    :first_btn="firstButton"
    :loading="loading"
    :second_btn="firstButton === $t('Common.Cancel') ? $t('Common.Close') : null"
    :title="modalTitle"
    :without_first_btn="$slots.firstBtn"
    @apply="apply"
    @close="close">
    <template #activator-btn>
      <slot
        v-if="btnText"
        name="activatorBtn"
        :open="open">
        <MenuItem
          v-if="list"
          class="h11-links"
          :data-qa="`${dataQa}-list-item`"
          :label="btnText"
          @click="open"/>
        <sButton
          v-else
          :data-qa="`${dataQa}-btn`"
          @click="open">
          {{ btnText }}
        </sButton>
      </slot>
    </template>
    <template #card-text>
      <sForm
        ref="modalInputTemplate"
        :data-qa="`${dataQa}-form`"
        :disabled="loading"
        label-position="top"
        label-width="0px"
        :model="form"
        :rules="mutableOptions.rules">
        <sFormItem
          :label="mutableOptions.inputLabel"
          prop="text">
          <sInput
            :data-qa="`${dataQa}-form-textarea`"
            :max-length="mutableOptions.maxLength"
            max-rows="15"
            rows="5"
            show-word-limit
            type="textarea"
            :value.sync="form.text"/>
        </sFormItem>
        <slot name="formItems"/>
      </sForm>
    </template>
    <template #first_btn>
      <slot
        :close="close"
        name="firstBtn"
        :text="form.text"/>
    </template>
  </DialogTemplateToolkit>
</template>
<script>
import MenuItem from 'components/common/MenuItem.vue'
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

import { componentOptions, validateRuls } from 'mixins'

/**
 * Шаблон модалки с вводом инпута
 * - завершение тендера
 */
export default {
  name: 'ModalInputTemplate',
  mixins: [ componentOptions, validateRuls ],
  data() {
    return {
      dialog: false,
      form: {
        text: '',
      },
      loading: false,
      mutableOptions: {
        show: false,
        maxLength: 256,
        inputLabel: '',
        rules: {
          text: []
        },
      }
    }
  },
  methods: {
    checkForm() {
      return new Promise((resolve) => {
        this.$refs.modalInputTemplate.validate((valid) => {
          resolve(valid)
        })
      })
    },
    apply() {
      this.checkForm().then(async res => {
        if (res) {
          this.loading = true
          if (this.callback) {
            await this.callback(this.form.text)
          }
          this.close()
        }
      })
        .finally(() => {
          this.loading = false
        })
    },
    close() {
      this.form.text = ''
      this.dialog = false
      this.$emit('close')
    },
    open() {
      this.dialog = true
      this.$emit('open')
    },
  },
  computed: {
    modalShow() {
      return this.dialog || this.mutableOptions.show
    },
    formComputed: {
      get() {
        return {...this.form, ...this.formData || {}}
      },
      set(val) {
        this.form = val
      }
    }
  },
  watch: {
    formData: {
      immediate: true,
      handler(val) {
        this.form = {...this.form, ...val}
      }
    }
  },
  props: {
    modalTitle: String,
    firstButton: {
      type: String,
      default: 'Tenders.Complete'
    },
    btnText: String,
    formData: Object,
    list: Boolean,
    callback: {
      type: Function,
      default: () => {}
    },
    dataQa: {
      type: String,
      default: 'cancel-tender'
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  created() {
    if (!this.options.rules) {
      this.mutableOptions.rules.text.push(this.commentValidateRule[0])
    }
  },
  components: {
    MenuItem,
    DialogTemplateToolkit
  },
}
</script>
